// eslint-disable-next-line no-shadow
export enum StudioMediaTypeEnums {
	IMAGE = 'Image',
	VIDEO = 'Video',
	NARRATOR = 'Narrator',
}
